import { Button, ButtonProps } from "@chakra-ui/react"
import { useFormikContext } from "formik"
import { forwardRef } from "react"
import { useColorModeValue } from "../chakra/ui/color-mode"
import useTranslate from "../lng/useTranslate"

type DiscardButtonProps = ButtonProps & {
  loading?: boolean
  // Optionally prevent the discard action
  // from resetting the form state.
  preventDiscard?: boolean
  onDiscard?: () => void
  /** When true, the button stays enabled when the form is pristine (not dirty). Default requires dirty to enable. */
  ignoreDirty?: boolean
}

const DiscardButton = forwardRef<HTMLButtonElement, DiscardButtonProps>(
  (props, ref): JSX.Element => {
    const {
      loading,
      preventDiscard,
      onDiscard,
      onClick,
      ignoreDirty,
      ...rest
    } = props
    const { t } = useTranslate()
    const form = useFormikContext()
    const colorPalette = useColorModeValue("brand", undefined)
    const isLoading = loading || form.isSubmitting

    // Awaiting seems to ensure the form is validedted properly based
    // on the latest values.
    async function handleDiscard(e: React.MouseEvent<HTMLButtonElement>) {
      if (!preventDiscard) {
        await form.handleReset()
        await form.validateForm()
        onDiscard?.()
      }
      onClick?.(e)
    }

    return (
      <Button
        ref={ref}
        variant="solid"
        colorPalette={colorPalette}
        width="full"
        cursor="pointer"
        disabled={!onClick && (isLoading || (!ignoreDirty && !form.dirty))}
        onClick={handleDiscard}
        {...rest}
      >
        {rest.children ||
          (isLoading || form.dirty ? t("Discard") : t("Cancel"))}
      </Button>
    )
  }
)

export default DiscardButton
